<!--  -->
<template>
  <div class="responsibility-main">
    <div id="responsibility" class="responsibilityStyle"></div>
  </div>
</template>

<script>
export default {
  name: "responsibilityMain",
  data() {
    return {};
  },
  mounted() {
    this.drawLine();
  },
  methods: {
    drawLine() {
      // 基于准备好的dom，初始化echarts实例
      let responsibility = this.$echarts.init(
        document.getElementById("responsibility")
      );

      var weatherIcons = {
        Sunny: 7 + "data/asset/img/weather/sunny_128.png",
        Cloudy: 8 + "data/asset/img/weather/cloudy_128.png",
        Showers: 9 + "data/asset/img/weather/showers_128.png"
      };

      // 绘制图表
      responsibility.setOption({
        tooltip: {
          trigger: "item",
          formatter: "{b} : {c} ({d}%)"
        },
        legend: {
          orient: "vertical",
          // top: 'middle',
          bottom: 25,
          left: "center",
          textStyle: { color: "#ffffff" },
          data: ["职称:助理工程师", "工程师", "高级工程师", "教授级高工"]
        },
        series: [
          {
            label: {
              normal: {
                position: "inner",
                show: false
              }
            },
            label: {
              //饼图图形上的文本标签
              normal: {
                show: true,
                position: "inner", //标签的位置
                textStyle: {
                  fontWeight: 500,
                  fontSize: 10 //文字的字体大小,
                  //   color:'red'
                },
                formatter: "{d}"
              }
            },
            color: ["#0083D0", "#67EEFF", "#7E9E86", "#E98F6F"],
            type: "pie",
            radius: "80%",
            center: ["50%", "35%"],
            selectedMode: "single",

            labelLine: {
              normal: {
                show: false
              }
            },
            data: [
              { value: 1548, name: "职称:助理工程师" },
              { value: 510, name: "工程师" },
              { value: 510, name: "高级工程师" },
              { value: 510, name: "教授级高工" }
            ]
          }
        ]
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.responsibilityStyle {
  width: 100%;
  height: 100%;
}
</style>
